var SubtitleTabsData = {};

$(document).ready(function () {
    // Toogle buttons
    $('.btn-toolbar a').on('click', function () {
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
    });
});

module.exports = SubtitleTabsData;



//////////////////
// WEBPACK FOOTER
// ./src/modules/SubtitleTabsData/SubtitleTabsData.js
// module id = 1
// module chunks = 0